import { defineComponent as _defineComponent } from 'vue'
import { ref, computed } from 'vue';
import { useStore } from 'vue2-helpers/vuex';
import useFormattedDateTime from '@/mixins/useFormattedDateTime';
import BCXUserBanner from '@/components/molecules/BCXUserBanner.vue';
import Voting from '@/components/voting/Voting.vue';
import Reporting from '@/components/voting/Reporting.vue';
import useI18n from '@/mixins/useI18n';
import useProjectGuestState from '@/state/projectGuestState';
import CreateMessage from './CreateMessage.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ThreadEntry',
  props: {
  entryUser: { type: Object, default: undefined },
  entryCount: { type: String, default: undefined },
  voteResult: { type: Number, default: 0 },
  userVoted: { type: String, default: undefined },
  flagged: { type: Boolean, default: false },
  forumId: { type: String, default: undefined },
  groupId: { type: String, default: undefined },
  threadId: { type: String, default: undefined },
  messageId: { type: String, default: undefined },
  messageEdited: { type: Boolean, default: false },
  created: { type: String, default: '' },
  subReplyText: { type: [String, Boolean], default: false },
  disableReply: { type: Boolean, default: false }
},
  emits: ['edit-message', 'post-message'],
  setup(__props, { emit }) {

const props = __props;





const store = useStore();
const { getFormattedTimeByAge } = useFormattedDateTime();

const createdTimestamp = computed(() => getFormattedTimeByAge(props.created));
const isMobileLayout = computed(() => store.getters['page/isMobileLayout']);
const isSmartphoneWidth = computed(() => store.state.page.isSmartphoneWidth);
const lastMessageText = computed(() => store.state.forum.lastMessageText);
const getOpenReplyToMessageId = computed(() => store.getters['forum/getOpenReplyToMessageId']);
const getThreadTopic = computed(() => store.getters['forum/getThreadTopic']);
const user = computed(() => store.getters.user);
const { projectGuestList } = useProjectGuestState(store.state.project?.company?.id);

const { t } = useI18n();

const classMobile = computed(() => (isMobileLayout.value ? 'is-mobile' : ''));

const createMessageVisible = computed({
  get: () => props.messageId === getOpenReplyToMessageId.value,
  set: (messageId: string) => {
    store.dispatch('forum/replyToMessage', messageId);
  }
});

const isUserCreator = computed(() => user.value.userId === props.entryUser.userId);
const userCanEdit = computed(() => user.value.userId === props.entryUser.userId || user.value.roles.includes('FORUM_MODERATOR') || user.value.roles.includes('PROJECT_MODERATOR') || user.value.roles.includes('ADMIN'));
const isThreadTopic = computed(() => props.messageId === getThreadTopic.value.messageId);

function scrollToEntry(event: Event) {
  const element = event.target as HTMLElement;
  const entryId = element.getAttribute('href');
  if (entryId) {
    const threadEntry = document.querySelector(entryId);
    if (threadEntry) {
      threadEntry.classList.add('scroll-highlight');
      setTimeout(() => {
        threadEntry.classList.remove('scroll-highlight');
      }, 1250);
    }
    element.style.scrollMarginTop = '80px';
    element.scrollIntoView();
  }
}

function toggleCreateMessageVisible() {
  if (createMessageVisible.value) {
    createMessageVisible.value = '';
  } else {
    createMessageVisible.value = props.messageId;
  }
}

function editMessage() {
  emit('edit-message');
}

function postMessage(message: string) {
  const postMessage = {
    forumId: props.forumId,
    forumThreadId: props.threadId,
    messageContent: message,
    replyToMessageId: props.messageId,
    replyToUserId: props.entryUser.userId
  };
  emit('post-message', postMessage);
  createMessageVisible.value = false;
}

const createMessagePlaceholder = computed(() => {
  if (!store.state.projectForum.project.id.length) {
    return '';
  }
  if (user.value.userId === store.state.projectForum.project.creator.userId || projectGuestList.value.map((guest) => guest.id).includes(user.value.userId)) {
    return t('project-forum.placeholder.project-answer-op');
  }
  return t('project-forum.placeholder.project-answer-user');
});

return { __sfc: true,props, emit, store, getFormattedTimeByAge, createdTimestamp, isMobileLayout, isSmartphoneWidth, lastMessageText, getOpenReplyToMessageId, getThreadTopic, user, projectGuestList, t, classMobile, createMessageVisible, isUserCreator, userCanEdit, isThreadTopic, scrollToEntry, toggleCreateMessageVisible, editMessage, postMessage, createMessagePlaceholder, BCXUserBanner, Voting, Reporting, CreateMessage }
}

})